import SurfaceCard from "@/components/primitives/SurfaceCard";
import { SectionHead, StatGrid, TagRow } from "@/components/organization/kit";

interface MarketPresenceProps {
  marketShare?: string;
  daysOnMarket?: string;
  listToSaleRatio?: string;
  yearsInBusiness?: string;
  specializations?: string[];
}

const MarketPresence = ({ marketShare, daysOnMarket, listToSaleRatio, yearsInBusiness, specializations }: MarketPresenceProps) => {
  const items = [
    { label: "Market share", value: marketShare ? `${marketShare}%` : null },
    { label: "Avg days on market", value: daysOnMarket || null },
    { label: "List-to-sale ratio", value: listToSaleRatio ? `${listToSaleRatio}%` : null },
    { label: "Years in business", value: yearsInBusiness || null },
  ];
  const hasStats = items.some((s) => s.value != null);
  const hasSpecs = specializations && specializations.length > 0;

  if (!hasStats && !hasSpecs) return null;

  return (
    <SurfaceCard padding="lg" className="rounded-2xl">
      <SectionHead kicker="Market presence" title="Footprint & specializations" />

      {hasStats && <StatGrid items={items} cols={4} />}

      {hasSpecs && (
        <div className={hasStats ? "mt-6" : ""}>
          <div className="eyebrow mb-3 text-ink-500">Specializations</div>
          <TagRow tags={specializations as string[]} tone="teal" />
        </div>
      )}
    </SurfaceCard>
  );
};

export default MarketPresence;
